import { rem } from "polished"
import styled from "styled-components"
import { FeedbackType } from ".."

export const CheckContainer = styled.div`
  background: ${(p) => p.theme.colors.card.default};
  border: 1px solid ${(p) => p.theme.colors.softGrey};
  position: absolute;
  border-radius: 50%;
  top: 50%;
  left: 0;
  transform: translateY(-50%);
  height: 1.25rem;
  width: 1.25rem;
  pointer-events: none;
  transition: background 0.2s ease-in-out;
  display: flex;
  justify-content: center;
  align-items: center;
  svg {
    width: 0.75rem;
    height: 0.75rem;
    fill: #fff;
    opacity: 0;
  }
`

export const Label = styled.label`
  font-size: ${rem(14)};
  display: inline-block;
  margin-left: 0.5rem;
  font-size: 0.875rem;
`

export const RadioButton = styled.div<{ feedbackType?: FeedbackType }>`
  position: relative;
  display: flex;
  align-items: center;
  margin: 0.5rem 1rem 0.5rem 0;
  cursor: default;

  input {
    opacity: 0;
  }

  input {
    height: 1.25rem;
    width: 1.25rem;
  }

  p {
    margin: 0 0.75rem;
    display: block;
    font-size: 0.875rem;
  }

  input:checked ~ ${CheckContainer} {
    background: ${(p) => p.theme.colors.purple};
    svg {
      opacity: 1;
    }
  }
`
